import { z } from 'zod';
import { documentSchema } from './IDocument';

export const meetingEmailTemplateSchema = z
  .object({
    idMeetingEmailTemplate: z.number().default(-1),
    idLegalTransactionType: z.number().nullable().default(null),
    Title: z.string().default(''),
    Subject: z.string().default(''),
    Body: z.string().default(''),
    allowDataUpload: z.coerce.boolean().default(false),
    sendOnCreation: z.coerce.boolean().default(false),
    sendOnCancelling: z.coerce.boolean().default(false),
    sendOnReschedule: z.coerce.boolean().default(false),
    sendWithCalenderFile: z.coerce.boolean().default(false),
    DaysBeforeDate: z.number().nullable().default(null),
  })
  .extend({
    Documents: z.array(documentSchema).default([]),
  });

export type IMeetingEmailTemplate = z.infer<typeof meetingEmailTemplateSchema>;
